import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/lumi/src/lumi/src/components/lumi-rust/DiscoverStarters.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/lumi/src/lumi/src/components/NavBar.tsx");
